import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Text, Tooltip } from '@fragments';
import { SEQUENCE_ICONS } from '../../../../../enums/automations';
import { formatNumber, formatPercent } from '../../../utils/format';

// Where people stop (`funnel`): per enabled step, how many messages went out and how many people
// moved on. One neutral hue in two steps on one scale, with every value written beside its bar.
export default function Funnel({ studio: s, funnel }) {
  const { t } = useTranslation('studioAutomations');
  const widest = Math.max(1, ...funnel.map(row => row.sent));
  return <Card flat className="studio-automation-funnel" title={t('funnelTitle')} subtitle={t('funnelSubtitle')}
    action={<span className="studio-automation-funnel__legend" aria-hidden="true">
      <Text.caption contrast={6} left={<i className="is-sent" />}>{t('funnelSent')}</Text.caption>
      <Text.caption contrast={6} left={<i className="is-completed" />}>{t('funnelCompleted')}</Text.caption>
    </span>}>
    <ul className="studio-automation-funnel__rows">
      {funnel.map(row => {
        const Glyph = SEQUENCE_ICONS[row.step];
        const rate = row.sent ? row.completed / row.sent : null;
        const line = t('funnelRow', { sent: formatNumber(row.sent, s.locale), completed: formatNumber(row.completed, s.locale) });
        return <li key={row.step}>
          <Text.span contrast={8} left={<Glyph />} maxLines={1}>{t(`sequence_${row.step}`)}</Text.span>
          <Tooltip content={line}>
            <span className="studio-automation-funnel__track" role="img" aria-label={`${t(`sequence_${row.step}`)}: ${line}`}>
              <span className="studio-automation-funnel__bar is-sent" style={{ width: `${(row.sent / widest) * 100}%` }} />
              <span className="studio-automation-funnel__bar is-completed" style={{ width: `${(row.completed / widest) * 100}%` }} />
            </span>
          </Tooltip>
          <span className="studio-automation-funnel__values">
            <Text.span contrast={9}>{formatNumber(row.completed, s.locale)}</Text.span>
            <Text.caption contrast={6}>{formatPercent(rate, s.locale)}</Text.caption>
          </span>
        </li>;
      })}
    </ul>
  </Card>;
}
